import React from 'react';

export const PdfIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-pdf"
      style={{
        color: '#E03131',
        ...props.style
      }}
    />
  );
};
